// extracted by mini-css-extract-plugin
export default {"containerFoot":"Footer_containerFoot__FF+ka","foot":"Footer_foot__DPlWI"};